module.exports = __webpack_public_path__ + "img/aspe.72663d42.png";